export function getFocusableElements(container) {
  return Array.from(
    container?.querySelectorAll(
      'button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), a[href], [tabindex]:not([tabindex="-1"]), [contenteditable="true"]',
    ) || [],
  ).filter(el => {
    const style = window.getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
  });
}

export function createFocusTrap(container) {
  const focusable = getFocusableElements(container);
  if (focusable.length === 0) return { remove: () => {} };

  const handleKeyDown = e => {
    if (e.key !== 'Tab') return;

    const activeElement = document.activeElement;
    if (!container?.contains(activeElement)) return;

    const firstFocusable = focusable[0];
    const lastFocusable = focusable[focusable.length - 1];

    if (e.shiftKey && activeElement === firstFocusable) {
      e.preventDefault();
      lastFocusable.focus();
    } else if (!e.shiftKey && activeElement === lastFocusable) {
      e.preventDefault();
      firstFocusable.focus();
    }
  };
  document.addEventListener('keydown', handleKeyDown);

  return {
    remove: () => {
      document.removeEventListener('keydown', handleKeyDown);
    },
  };
}
